export default __webpack_public_path__ + "static/media/Download.c99a7717.svg";